(() => {
  if (customElements.get("read-more")) {
    return;
  }

  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        truncate: "[data-truncate]",
        full: "[data-full]",
      };
    }

    toggle(event) {
      const target = event.target;
      const closestTrunctate = target.closest(this.selectors.truncate);

      if (closestTrunctate) {
        this.truncate.classList.toggle("hidden");
        this.full.classList.toggle("hidden");
        return;
      }

      this.full.classList.toggle("hidden");
      this.truncate.classList.toggle("hidden");
    }

    connectedCallback() {
      this.truncate = this.querySelector(this.selectors.truncate);
      this.full = this.querySelector(this.selectors.full);
      this.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", this.toggle.bind(this));
      });
    }
  }

  customElements.define("read-more", ReadMore);
})();
